import { 
  FC, 
  // useState 
} from 'react';
import SignatureProcess from "../../SignatureProcess";

import {
  Button, FormHelperText,
  // Select, InputLabel, FormControl, MenuItem, SelectChangeEvent,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Stack, Typography
} from '@mui/material';
import { 
  INoCessionSIPSErrors,
  NoSIPSCessionSelection 
} from './types/noSIPSCession';
import { useTranslation } from 'react-i18next';

interface INoSIPSCessionDialogProps {
  errors: INoCessionSIPSErrors | undefined;
  isSubmitting: boolean;
  isWaitingForSignature: boolean;
  changeDialogSipsOpen: (open: boolean) => void;
  handleSubmitNoSIPSCession: (newSelect: NoSIPSCessionSelection) => void;
  open: boolean;
}

const NoSIPSCessionDialog: FC<INoSIPSCessionDialogProps> = ({
  errors,
  isSubmitting,
  isWaitingForSignature,
  handleSubmitNoSIPSCession,
  open,
  changeDialogSipsOpen
}) => {
  const { t } = useTranslation();
  
  // const [noSIPSCessionSelection, setNoSIPSCessionSelection] = 
  //   useState<NoSIPSCessionSelection>("all");

  const handleClose = () => {
    changeDialogSipsOpen(false)
  };

  const handleSend = () => {
    // handleSubmitNoSIPSCession(noSIPSCessionSelection);
    handleSubmitNoSIPSCession("actual");
  }

  // const handleChangeNoCessionSelection = (event: SelectChangeEvent) => {
  //   setNoSIPSCessionSelection(event.target.value as NoSIPSCessionSelection);
  // };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {t('common:text.sips_title')}
        </DialogTitle>
        <DialogContent>
          {!isWaitingForSignature &&
            <Stack direction="column" spacing={2}>

              <Typography>
                {t('common:text.sips_description')}
              </Typography>

              {/* <FormControl>
                <InputLabel shrink htmlFor="">
                  {t('common:text.sips_contracts')}
                </InputLabel>
                <Select
                  onChange={handleChangeNoCessionSelection}
                  value={noSIPSCessionSelection}
                  disabled={isSubmitting}
                  error={!!(errors?.noCessionSelection)}
                >
                  <MenuItem key="all" value="all">
                    {t('common:text.sips_all')}
                  </MenuItem>
                  <MenuItem key="actual" value="actual">
                    {t('common:text.sips_current')}
                  </MenuItem>
                </Select>
              </FormControl> */}

              {!!(errors?.noCessionSelection) &&
                <FormHelperText error={true}>
                  {errors.noCessionSelection[0]}
                </FormHelperText>
              }
              
            </Stack>
          }

          {isWaitingForSignature && <SignatureProcess />}

        </DialogContent>
        
        <DialogActions sx={{display: "flex", justifyContent: "space-between"}}>
          <Button
            color={'primary'}
            variant={'outlined'}
            onClick={handleClose}
          >
            {t('common:text.sips_close')}
          </Button>

          {!isWaitingForSignature &&
            <Button
              color={'primary'}
              variant={'contained'}
              disabled={isSubmitting}
              onClick={handleSend}
            >
              {t('common:text.sips_send')}
            </Button>
          }
        </DialogActions>
        
      </Dialog>
    </div>
  );
}

export default NoSIPSCessionDialog;
